import React, { useState, useRef, useEffect } from 'react';
import DesignationIcon from '../DesignationIcon';
import { ExistingPlaceWarning } from './SelectedPlaceCard';

const DESIGNATIONS = [
  { value: 'gem', label: 'Gem', description: 'A hidden gem worth the visit' },
  { value: 'highly-recommended', label: 'Highly Recommended', description: 'Personally recommended' },
  { value: 'visited', label: 'Visited', description: 'Been there, done that' },
  { value: 'avoid', label: 'Avoid', description: 'Skip this one' },
  { value: 'want-to-go', label: 'Want to Go', description: 'On your wishlist' },
];

function DesignationSelect({
  designation,
  onChange,
  existingPlaceInfo,
  duplicateError,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    onChange({ target: { name: 'designation', value } });
    setIsOpen(false);
  };

  const selectedDesignation = DESIGNATIONS.find(d => d.value === designation);

  return (
    <div className={`form-group designation-group ${!designation ? 'designation-required' : ''}`}>
      <label>Designation <span className="required-indicator">*</span></label>
      <div
        ref={selectRef}
        className={`designation-select-custom ${!designation ? 'designation-empty' : ''} ${isOpen ? 'open' : ''}`}
      >
        <button
          type="button"
          className="designation-select-trigger"
          onClick={() => setIsOpen(!isOpen)}
          aria-haspopup="listbox"
          aria-expanded={isOpen}
        >
          {selectedDesignation ? (
            <span className="designation-option-content">
              <DesignationIcon designation={selectedDesignation.value} size={16} />
              <span>{selectedDesignation.label}</span>
            </span>
          ) : (
            <span className="designation-placeholder">Select designation</span>
          )}
          <svg className="designation-select-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
        {isOpen && (
          <ul className="designation-select-dropdown" role="listbox">
            {DESIGNATIONS.map((d) => (
              <li
                key={d.value}
                className={`designation-option ${designation === d.value ? 'selected' : ''}`}
                onClick={() => handleSelect(d.value)}
                role="option"
                aria-selected={designation === d.value}
              >
                <DesignationIcon designation={d.value} size={16} />
                <span>{d.label}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
      {existingPlaceInfo && !duplicateError && (
        <ExistingPlaceWarning existingPlaceInfo={existingPlaceInfo} />
      )}
    </div>
  );
}

function AvoidReasonSelect({
  avoidReason,
  onChange,
}) {
  return (
    <div className="form-group">
      <label>Reason to Avoid</label>
      <select
        name="avoidReason"
        value={avoidReason}
        onChange={onChange}
        className="form-select"
        required
      >
        <option value="">Select reason</option>
        <option value="cost">Cost</option>
        <option value="service">Service</option>
        <option value="ambiance">Ambiance</option>
        <option value="quality">Quality</option>
        <option value="location">Location</option>
        <option value="cleanliness">Cleanliness</option>
      </select>
    </div>
  );
}

export { DesignationSelect, AvoidReasonSelect, DESIGNATIONS };
